import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { headersAuth } from '../../../../../../Services/AuthService';
import { servicios_grupogack_catalogo, tipo_riesgo } from '../../../../../../Constants/Constants';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';
import tipoRiesgoJson from '../../../../../Datos/tipoRiesgo.json';

const TipoRiesgo = ({ id, permisos }) => {
    const [ tiposRiesgo, setTiposRiesgo ] = useState( null );
    useEffect(() => {
        axiosTiposRiesgo();
    }, []);

    const axiosTiposRiesgo = () => {
         setTiposRiesgo( tipoRiesgoJson);
        /*
        axios.get( `${servicios_grupogack_catalogo}/tiporiesgo/`, headersAuth() )
            .then( respuesta => {
                //console.log( respuesta );
                switch( respuesta.data.status ){
                    case 200:
                        setTiposRiesgo( respuesta.data.dataResponse );
                        break;
                    case 404:
                        //setTiposRiesgo([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })*/
    }

    return (
        <div id={ id }>
            { tiposRiesgo ?
                <DataTableService id={id} title={ tipo_riesgo } permisos={permisos}
                    columns={[
                        { field: "riesgoPtoClave", title: "Clave" },
                        { field: "riesgoPtoDesc", title: "Descripción" },
                    ]}
                    data={ tiposRiesgo } /> : <SpinnerOval />
            }
        </div>
    );
};

export default TipoRiesgo;